<template>
  <div class="home" v-if="client">
    <img class="logo" :src="client.logo" />
    <div class="audio" v-if="client.video_audio" @click="muted = !muted">
      <img v-if="muted" src="@/assets/img/volume.svg" />
      <img v-if="!muted" src="@/assets/img/mute.svg" />
    </div>
    <video
      ref="video"
      :src="
        client.video
          ? client.video
          : require('@/assets/img/available_homes.mp4')
      "
      autoplay
      loop
      :muted="muted"
    ></video>
    <div class="dark"></div>
    <div class="choices">
      <div class="choice" @click="goTo('/community')">
        <img src="@/assets/img/community.svg" />
        <h2>Our Community</h2>
      </div>
      <div class="choice" @click="goTo('/photogallery')">
        <img src="@/assets/img/camera.png" />
        <h2>Photo Gallery</h2>
      </div>
      <div class="choice" @click="goTo('/available-homes')">
        <img src="@/assets/img/home.svg" />
        <h2>Available Homes</h2>
      </div>
      <div class="choice" @click="goTo('/calendar')">
        <img src="@/assets/img/calendar.svg" />
        <h2>Community Calendar</h2>
      </div>
    </div>
  </div>
</template>

<script>
import { db, functions, analytics } from "@/config/firebaseInit";
import QrcodeVue from "qrcode.vue";

export default {
  name: "home",
  components: {
    QrcodeVue,
  },
  data() {
    return {
      isMobile: false,
      client: this.$store.state.client,
      user: this.$store.state.user,
      muted: true,
      getListings: functions.httpsCallable("formatAllListingsScheduledCall"),
    };
  },
  mounted() {},
  async created() {
    this.getListings();
  },
  watch: {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.home {
  height: 100vh;
  width: 100vw;
}

.audio {
  position: fixed;
  top: 50px;
  right: 50px;
  height: 100px;
  width: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 100%;
  z-index: 9;
  img {
    height: 30px;
    filter: brightness(0) invert(1);
  }
}

.dark {
  position: fixed;
  height: 100%;
  width: 100%;
  background: linear-gradient(rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.9));
  bottom: 0;
  left: 0;
  z-index: 1;
}

.choices {
  width: 100%;
  position: fixed;
  bottom: 75px;
  display: flex;
  justify-content: center;
  z-index: 2;
  .choice {
    display: flex;
    align-items: center;
    padding: 30px 40px;
    margin: 30px 15px;
    background: rgba(255, 255, 255, 0.4);
    img {
      filter: brightness(0) invert(1);
      height: 50px;
      margin-bottom: 0;
      opacity: 0.5;
      margin-right: 20px;
    }
    h2 {
      margin: 0;
      font-size: 26px;
      text-transform: uppercase;
      max-width: 200px;
    }
  }
}

.logo {
  position: absolute;
  transform: none;
  left: 100px;
  width: 300px;
  margin-top: 50px;
  z-index: 2;
}
</style>
